import { useState, useEffect, useCallback } from "react";
import { Outlet, useLocation, useOutletContext } from "react-router-dom";
import BreadCrumb from "components/utils/BreadCrumb.js";
import PathUtils from "utils/PathUtils.js";

export default function Patients() {
  const [hospitalId] = useOutletContext();
  const location = useLocation();
  const [breadCrumbPathElements, setBreadCrumbPathElements] = useState([
    "Home",
    "Patients",
  ]);

  const updateBreadCrumbPath = useCallback(() => {
    setBreadCrumbPathElements(
      PathUtils.extractBreadCrumbTokens(location.pathname)
    );
  }, [location]);

  useEffect(() => {
    updateBreadCrumbPath();
  }, [location, updateBreadCrumbPath]);

  return (
    <div>
      <BreadCrumb pathElements={breadCrumbPathElements} />
      <Outlet context={[hospitalId]} />
    </div>
  );
}
